import React from "react";
import moment from "moment";
import { apiRequest } from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import RenderChart from "../../common/Chart/RenderChart";
import { getChartData } from "../../../utils/graph_service";
import { SECTIONS } from "../../../constants/appConstants";
import VisibilityIcon from "@material-ui/icons/Visibility";
import {
	AppBar,
	Dialog,
	DialogContent,
	DialogContentText,
	DialogTitle,
	IconButton,
	Toolbar,
	Tooltip,
	Typography
} from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import DenseTable from "../../Dashboard/RenderTable";
import {
	GetSectionPermission,
	getSynchStatus,
	PaperComponent
} from "../../../utils/helper";
import { IoMdCloseCircleOutline } from "react-icons/io";

const CData = [
	{ key: "WorkOrderId", name: "Work Order Id" },
	{ key: "JobType", name: "Job Type" },
	{ key: "JobPriority", name: "Job Priority" },
	{ key: "Name", name: "Name" },
	{ key: "AssetId", name: "Asset Id" },
	{ key: "ReceivedDate", name: "Received Date", format: "DateTime" },
	{ key: "DueDate", name: "Due Date", format: "DateTime" },
	{ key: "ClosedDate", name: "Closed Date", format: "DateTime" },
	{ key: "Requestor", name: "Requestor" },
  { key: "ServiceLocation", name: "Service Location" },
  { key: "Type", name: "Type" },
	{ key: "WorkOrderStatus", name: "Status" },
	{ key: "ServiceDescription", name: "Description", width: 450 },
	{ key: "Source", name: "Source" }
];

const configData = {
	trend: {
		type: "Month",
		key: "ReceivedDate"
	},
	columns: [
		{
			key: "",
			name: "Visitors (Escort Required)",
			type: "count",
			filters: [
				{
					key: "JobType",
					values: ["Escort", "Grant Access"]
				},
				{
					key: "Status",
					values: ["Approved", "Denied"]
				}
			],
			color: "#E59400",
			sortOrder: 0
		},
		{
			key: "",
			name: "Visitor Access Required",
			type: "count",
			filters: [
				{
					key: "JobType",
					values: ["Access Request", "Access Cards", "Grant Access"]
				},
				{
					key: "Status",
					values: ["Approved", "Denied"]
				}
			],
			color: "#007300",
			sortOrder: 1
		},
		{
			key: "",
			name: "Access Removed/Terminated",
			type: "count",
			filters: [
				{
					key: "JobType",
					values: ["Remove Access", "Access Removal"]
				},
				{
					key: "Status",
					values: ["Approved", "Denied"]
				}
			],
			color: "#D14040",
			sortOrder: 2
		},
		{
			key: "PendingRequest",
			name: "Pending Request",
			type: "count",
			filters: [
				{
					key: "JobType",
					values: ["Grant Access", "Remove Access", "Access Removal"]
				},
				{
					key: "Status",
					values: ["In Progress", "Created"]
				}
			],
			color: "#3f51b5",
			sortOrder: 3
		}
	]
};
let resDataGraph = undefined;
class HealthAndSafetyBarChart extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			IncidentReportsData: undefined,
			serriesStartDate: this.props.startDate,
			serriesEndDate: this.props.endDate,
			rawData: [],
			SortedRawData: [],
			IsConditionOpen: false,
			FiltersView: false,
			syncStatus: "NA"
		};
	}

	componentDidMount() {
		this.GetIncidentReportsData(
			this.props.propertyId,
			this.props.startDate,
			this.props.endDate
		);
	}

	componentWillReceiveProps(newProps) {
		if (
			newProps.propertyId != this.props.propertyId ||
			newProps.startDate != this.props.startDate ||
			newProps.endDate != this.props.endDate
		) {
			this.GetIncidentReportsData(
				newProps.propertyId,
				newProps.startDate,
				newProps.endDate
			);
		}
	}

	/** Incident report data */
	GetIncidentReportsData = (propertyId, startDate, endDate) => {
		const params = {
			propertyId: propertyId,
			startDate: startDate,
			endDate: endDate
		};
		apiRequest({
			url: API_URL.SiteVisitorSummary.GetSiteVisitorSummaryByDate,
			params
		}).then(IncidentReports => {
			resDataGraph = getChartData(
				IncidentReports.rawData || [],
				configData,
				startDate,
				endDate
			);
			this.setState({
				IncidentReportsData: resDataGraph,
				rawData: IncidentReports.data,
				startDate: startDate,
				endDate: endDate,
				syncStatus: ((IncidentReports.syncStatus || [])[0] || {}).SyncStatus
			});
		});
	};

	/** Key value data */
	getKeyValueData = (data, configuration, withPercent) => {
		const resData = [];
		let totalCount = 0;
		const colors = [];
		const columns = configuration.columns;
		columns.map((item ,index)=> {
			const filters = item.filters;
			let count = 0;
			const columnData = data;
			filters.forEach(element => {
				const result = columnData.filter(function(v) {
					return (
						v[element.key] ==
						element.values.find(value => value == v[element.key])
					);
				});
				count = count + (result || []).length;
			});
			totalCount += count;
			const color = item.color || colors[index];
			colors.push(color);
			resData.push({ attributeValue: count, attributeName: item.name });
		});
		if (withPercent) {
			for (let i = 0; i < resData.length; i++) {
				resData[i].percentage = Math.round(
					(resData[i].attributeValue / totalCount) * 100
				);
			}
			return { data: resData, colors: colors };
		}
		return resData;
	};

	/** series */
	getSeries = () => {
		const result = [];
		const startDate = moment(this.state.serriesStartDate);
		const endDate = moment(this.state.serriesEndDate);

		while (startDate.isBefore(endDate)) {
			result.push(startDate.format("MMM"));
			startDate.add(1, "month");
		}
		if (startDate == endDate) {
			result.push(startDate.format("MMM"));
		}
		return result;
	};

	/** Total count */
	totalCount = (array, key) => {
		return array.reduce((r, a) => {
			return r + a[key];
		}, 0);
	};

	/** Details by attribute and type */
	getDetailByAttributeAndType = () => {
		const RawData = [];
		const FilterKeys = [
			"Escort",
			"Access Request",
			"Access Cards",
			"Access Removal",
			"Grant Access",
			"Remove Access"
		];
		const SortedRawData = this.state.rawData;

		let outPut;
		FilterKeys.map(item => {
			outPut = SortedRawData.filter(value => value.JobType == item);
			RawData.push({ type: outPut, title: item });
		});

		// console.log("---", RawData);

		this.setState({
			SortedRawData: RawData,
			IsConditionOpen: true,
			FiltersView: false,
		});
	};

	render() {
		const SITE_PERSONNEL_ACTIVITY_GRAPH = GetSectionPermission(
			SECTIONS.SECURITY_AND_OPERATION,
			SECTIONS.SITE_PERSONNEL_ACTIVITY_GRAPH
		);

		const {
			rawData,
			SortedRawData,
			IsConditionOpen,
			FiltersView
		} = this.state;

		
		return (
			<>
				<div className={"w-100  graph-title-hAnds"}>
					<div className={"w-50 pt-5 "}>{"Site Personnel Activity Graph"}</div>

					<div className={"w-50"} style={{ textAlign: "right" }}>
						{SITE_PERSONNEL_ACTIVITY_GRAPH.showData && (
							<>
								<Tooltip title={"View Filters"}>
									<IconButton
										size={"small"}
										onClick={() =>
											this.setState({
												IsConditionOpen: true,
												FiltersView: true,
											})}
									>
										<InfoOutlined size={"small"} fontSize={"small"} />
									</IconButton>
								</Tooltip>

								<Tooltip title={"View Data"}>
									<IconButton
										size={"small"}
										onClick={this.getDetailByAttributeAndType}
									>
										<VisibilityIcon
											size={"small"}
											fontSize={"small"}
										/>
									</IconButton>
								</Tooltip>
							</>
						)}
					</div>
				</div>
				<div id={"HealthAndSafetyPie"}>
					{this.state.IncidentReportsData ? (
						<RenderChart
							identifier={"Legends"}
							allowDrillDown={false}
							chartConfig={{
								startDate: this.state.startDate,
								endDate: this.state.endDate,
								data: resDataGraph.data,
								type: "GroupBarChart",
								keys: resDataGraph.barKeys,
								colors: resDataGraph.barColors,
								accessor: resDataGraph.chartAccessor.mainAccessor,
								configuration: configData,
								rawData: rawData
							}}
							legends={resDataGraph.legends}
						/>
					) : null}
				</div>

				{IsConditionOpen && (
					<Dialog
						maxWidth={"md"}
						open={IsConditionOpen}
						onClose={() =>
							this.setState({ IsConditionOpen: false, FiltersView: false })}
						PaperComponent={PaperComponent}
						aria-labelledby={"responsive-dialog-title"}
						fullScreen={!FiltersView}
					>
						<AppBar
							style={{ position: "relative", backgroundColor: "#064473" }}
						>
							<Toolbar>
								<Typography
									variant={"h6"}
									style={{ flex: "1" }}
								>
									<DialogTitle
										style={{ cursor: "move" }}
										id={"responsive-dialog-title"}
										className={""}
									>
										{"Site Personnel Activity Graph\r"}
										<span className={"condition-label white-label"}>
											{"(Applied filters)\r"}
										</span>
									</DialogTitle>
								</Typography>
								<Tooltip title={"Close"}>
									<IconButton
										edge={"end"}
										color={"inherit"}
										onClick={() => {
											this.setState({
												IsConditionOpen: false,
												FiltersView: false
											});
										}}
										aria-label={"close"}
										className={"white-button"}
									>
										<IoMdCloseCircleOutline />
									</IconButton>
								</Tooltip>
							</Toolbar>
						</AppBar>
						<DialogContent>
							<DialogContentText>
								{FiltersView ? (
									configData.columns &&
									configData.columns.map(item => (
										<div className={"col-xs-12"}>
											<div className={"col-xs-12 start-xs condition-heading"}>
												<b>{item.name}</b>{" "}
											</div>
											<div>
												<div className={"col-xs-11 condition-label"}>
													{"Received Date: From "}{this.props.startDate}{" To"}{" "}
													{this.props.endDate}
												</div>
												<div className={"col-xs-11 condition-label"}>
													{"Job Type: "}{item.filters[0].values.join()}
												</div>
											</div>
										</div>
									))
								) : (
									<>
										<div>
											{SortedRawData.map(item => (
												<>
													<div>
														<h3>{item.title}</h3>
													</div>
													<hr />
													<DenseTable
														columns={CData}
														data={item.type}
														config={{
															minRows: 10
														}}
													/>
												</>
											))}
										</div>
									</>
								)}
								{FiltersView ? (
									<span className={"data-sync-text"}>
										{/* {localStorage.getItem("syncStatus")} */}
										{getSynchStatus(this.state.syncStatus)}
									</span>
								) : null}
							</DialogContentText>
						</DialogContent>
					</Dialog>
				)}
			</>
		);
	}
}

export default HealthAndSafetyBarChart;
